/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */
import type {
  AddYoutubeChannelRequestDto,
  AddYoutubeChannelResponseDto,
  ChannelAnalyticsControllerGetChannelAnalyticsApiV1Params,
  ChannelAnalyticsControllerGetChannelVideosAnalyticsApiV1Params,
  DeleteChannelsRequestDto,
  FavoriteMusicRequestDto,
  GetAvailableDataUntilResponseDto,
  GetChannelAnalyticsResponseDto,
  GetChannelVideosSummaryAnalyticsResponseDto,
  GetChannelsResponseDto,
  GetMoodResponseDto,
  GetPayoutDetailsResponseDto,
  GetPayoutHistoryResponseDto,
  GetPayoutStatusResponseDto,
  MusicControllerGetMusicsApiV1Params,
  PaginatedMusicsResponseDto,
  UpsertPayoutDetailsRequestDto
} from './models'
import { apiClient } from '../client';


export type musicControllerGetMusicsApiV1Response = {
  data: PaginatedMusicsResponseDto;
  status: number;
  headers: Headers;
}

export const getMusicControllerGetMusicsApiV1Url = (params?: MusicControllerGetMusicsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  return normalizedParams.size ? `http://localhost:8888/api/v1/musics?${normalizedParams.toString()}` : `http://localhost:8888/api/v1/musics`
}

export const musicControllerGetMusicsApiV1 = async (params?: MusicControllerGetMusicsApiV1Params, options?: RequestInit): Promise<musicControllerGetMusicsApiV1Response> => {
  
  return apiClient<musicControllerGetMusicsApiV1Response>(getMusicControllerGetMusicsApiV1Url(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type musicControllerGetMoodsApiV1Response = {
  data: GetMoodResponseDto;
  status: number;
  headers: Headers;
}

export const getMusicControllerGetMoodsApiV1Url = () => {


  return `http://localhost:8888/api/v1/musics/moods`
}

export const musicControllerGetMoodsApiV1 = async ( options?: RequestInit): Promise<musicControllerGetMoodsApiV1Response> => {
  
  return apiClient<musicControllerGetMoodsApiV1Response>(getMusicControllerGetMoodsApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type musicControllerFavoriteMusicApiV1Response = {
  data: void;
  status: number;
  headers: Headers;
}

export const getMusicControllerFavoriteMusicApiV1Url = () => {


  return `http://localhost:8888/api/v1/musics/favorite`
}

export const musicControllerFavoriteMusicApiV1 = async (favoriteMusicRequestDto: FavoriteMusicRequestDto, options?: RequestInit): Promise<musicControllerFavoriteMusicApiV1Response> => {
  
  return apiClient<musicControllerFavoriteMusicApiV1Response>(getMusicControllerFavoriteMusicApiV1Url(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      favoriteMusicRequestDto,)
  }
);}



export type musicControllerUnfavoriteMusicApiV1Response = {
  data: void;
  status: number;
  headers: Headers;
}

export const getMusicControllerUnfavoriteMusicApiV1Url = () => {


  return `http://localhost:8888/api/v1/musics/unfavorite`
}

export const musicControllerUnfavoriteMusicApiV1 = async (favoriteMusicRequestDto: FavoriteMusicRequestDto, options?: RequestInit): Promise<musicControllerUnfavoriteMusicApiV1Response> => {
  
  return apiClient<musicControllerUnfavoriteMusicApiV1Response>(getMusicControllerUnfavoriteMusicApiV1Url(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      favoriteMusicRequestDto,)
  }
);}



export type channelControllerGetChannelsApiV1Response = {
  data: GetChannelsResponseDto;
  status: number;
  headers: Headers;
}

export const getChannelControllerGetChannelsApiV1Url = () => {


  return `http://localhost:8888/api/v1/channels`
}

export const channelControllerGetChannelsApiV1 = async ( options?: RequestInit): Promise<channelControllerGetChannelsApiV1Response> => {
  
  return apiClient<channelControllerGetChannelsApiV1Response>(getChannelControllerGetChannelsApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type channelControllerDeleteChannelApiV1Response = {
  data: void;
  status: number;
  headers: Headers;
}

export const getChannelControllerDeleteChannelApiV1Url = () => {


  return `http://localhost:8888/api/v1/channels`
}

export const channelControllerDeleteChannelApiV1 = async (deleteChannelsRequestDto: DeleteChannelsRequestDto, options?: RequestInit): Promise<channelControllerDeleteChannelApiV1Response> => {
  
  return apiClient<channelControllerDeleteChannelApiV1Response>(getChannelControllerDeleteChannelApiV1Url(),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteChannelsRequestDto,)
  }
);}



export type channelControllerAddYoutubeChannelApiV1Response = {
  data: AddYoutubeChannelResponseDto | void;
  status: number;
  headers: Headers;
}

export const getChannelControllerAddYoutubeChannelApiV1Url = () => {


  return `http://localhost:8888/api/v1/channels`
}

export const channelControllerAddYoutubeChannelApiV1 = async (addYoutubeChannelRequestDto: AddYoutubeChannelRequestDto, options?: RequestInit): Promise<channelControllerAddYoutubeChannelApiV1Response> => {
  
  return apiClient<channelControllerAddYoutubeChannelApiV1Response>(getChannelControllerAddYoutubeChannelApiV1Url(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addYoutubeChannelRequestDto,)
  }
);}



export type payoutControllerRequestWithdrawalApiV1Response = {
  data: void | void;
  status: number;
  headers: Headers;
}

export const getPayoutControllerRequestWithdrawalApiV1Url = () => {


  return `http://localhost:8888/api/v1/payout/withdrawals`
}

export const payoutControllerRequestWithdrawalApiV1 = async ( options?: RequestInit): Promise<payoutControllerRequestWithdrawalApiV1Response> => {
  
  return apiClient<payoutControllerRequestWithdrawalApiV1Response>(getPayoutControllerRequestWithdrawalApiV1Url(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



export type payoutControllerGetPayoutHistoryApiV1Response = {
  data: GetPayoutHistoryResponseDto;
  status: number;
  headers: Headers;
}

export const getPayoutControllerGetPayoutHistoryApiV1Url = () => {


  return `http://localhost:8888/api/v1/payout/withdrawals`
}

export const payoutControllerGetPayoutHistoryApiV1 = async ( options?: RequestInit): Promise<payoutControllerGetPayoutHistoryApiV1Response> => {
  
  return apiClient<payoutControllerGetPayoutHistoryApiV1Response>(getPayoutControllerGetPayoutHistoryApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type payoutControllerGetPayoutStatusApiV1Response = {
  data: GetPayoutStatusResponseDto;
  status: number;
  headers: Headers;
}

export const getPayoutControllerGetPayoutStatusApiV1Url = () => {


  return `http://localhost:8888/api/v1/payout/status`
}

export const payoutControllerGetPayoutStatusApiV1 = async ( options?: RequestInit): Promise<payoutControllerGetPayoutStatusApiV1Response> => {
  
  return apiClient<payoutControllerGetPayoutStatusApiV1Response>(getPayoutControllerGetPayoutStatusApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type payoutControllerGetPayoutDetailsApiV1Response = {
  data: GetPayoutDetailsResponseDto;
  status: number;
  headers: Headers;
}

export const getPayoutControllerGetPayoutDetailsApiV1Url = () => {


  return `http://localhost:8888/api/v1/payout/details`
}

export const payoutControllerGetPayoutDetailsApiV1 = async ( options?: RequestInit): Promise<payoutControllerGetPayoutDetailsApiV1Response> => {
  
  return apiClient<payoutControllerGetPayoutDetailsApiV1Response>(getPayoutControllerGetPayoutDetailsApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type payoutControllerUpdatePayoutDetailsApiV1Response = {
  data: void;
  status: number;
  headers: Headers;
}

export const getPayoutControllerUpdatePayoutDetailsApiV1Url = () => {


  return `http://localhost:8888/api/v1/payout/details`
}

export const payoutControllerUpdatePayoutDetailsApiV1 = async (upsertPayoutDetailsRequestDto: UpsertPayoutDetailsRequestDto, options?: RequestInit): Promise<payoutControllerUpdatePayoutDetailsApiV1Response> => {
  
  return apiClient<payoutControllerUpdatePayoutDetailsApiV1Response>(getPayoutControllerUpdatePayoutDetailsApiV1Url(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPayoutDetailsRequestDto,)
  }
);}



export type channelAnalyticsControllerGetChannelAnalyticsApiV1Response = {
  data: GetChannelAnalyticsResponseDto;
  status: number;
  headers: Headers;
}

export const getChannelAnalyticsControllerGetChannelAnalyticsApiV1Url = (id: string,
    params?: ChannelAnalyticsControllerGetChannelAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  return normalizedParams.size ? `http://localhost:8888/api/v1/analytics/channels/${id}?${normalizedParams.toString()}` : `http://localhost:8888/api/v1/analytics/channels/${id}`
}

export const channelAnalyticsControllerGetChannelAnalyticsApiV1 = async (id: string,
    params?: ChannelAnalyticsControllerGetChannelAnalyticsApiV1Params, options?: RequestInit): Promise<channelAnalyticsControllerGetChannelAnalyticsApiV1Response> => {
  
  return apiClient<channelAnalyticsControllerGetChannelAnalyticsApiV1Response>(getChannelAnalyticsControllerGetChannelAnalyticsApiV1Url(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type channelAnalyticsControllerGetChannelVideosAnalyticsApiV1Response = {
  data: GetChannelVideosSummaryAnalyticsResponseDto;
  status: number;
  headers: Headers;
}

export const getChannelAnalyticsControllerGetChannelVideosAnalyticsApiV1Url = (id: string,
    params: ChannelAnalyticsControllerGetChannelVideosAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  return normalizedParams.size ? `http://localhost:8888/api/v1/analytics/channels/${id}/videos/summary?${normalizedParams.toString()}` : `http://localhost:8888/api/v1/analytics/channels/${id}/videos/summary`
}

export const channelAnalyticsControllerGetChannelVideosAnalyticsApiV1 = async (id: string,
    params: ChannelAnalyticsControllerGetChannelVideosAnalyticsApiV1Params, options?: RequestInit): Promise<channelAnalyticsControllerGetChannelVideosAnalyticsApiV1Response> => {
  
  return apiClient<channelAnalyticsControllerGetChannelVideosAnalyticsApiV1Response>(getChannelAnalyticsControllerGetChannelVideosAnalyticsApiV1Url(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type channelAnalyticsControllerGetAvailableDataUntilApiV1Response = {
  data: GetAvailableDataUntilResponseDto;
  status: number;
  headers: Headers;
}

export const getChannelAnalyticsControllerGetAvailableDataUntilApiV1Url = () => {


  return `http://localhost:8888/api/v1/analytics/channels/metadata/available-data-until`
}

export const channelAnalyticsControllerGetAvailableDataUntilApiV1 = async ( options?: RequestInit): Promise<channelAnalyticsControllerGetAvailableDataUntilApiV1Response> => {
  
  return apiClient<channelAnalyticsControllerGetAvailableDataUntilApiV1Response>(getChannelAnalyticsControllerGetAvailableDataUntilApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



